const pad = (n) => String(n).padStart(2, "0");

export const formatDateICS = (dt) => {
	dt = new Date(dt);

	return (
		dt.getUTCFullYear().toString() +
		pad(dt.getUTCMonth() + 1) +
		pad(dt.getUTCDate()) +
		"T" +
		pad(dt.getUTCHours()) +
		pad(dt.getUTCMinutes()) +
		pad(dt.getUTCSeconds()) +
		"Z"
	);
};

const escapeICS = (str = "") => {
	return String(str)
		.replace(/\\/g, "\\\\")
		.replace(/\n/g, "\\n")
		.replace(/,/g, "\\,")
		.replace(/;/g, "\\;");
};

export const buildCalendarLinks = ({ title, description, location, start, end }) => {
	const formattedStartDate = formatDateICS(start);
	const formattedEndDate = formatDateICS(end);
	const dates = `${formattedStartDate}/${formattedEndDate}`;

	const encodedTitle = encodeURIComponent(title);
	const encodedDesc = encodeURIComponent(description);
	const encodedLocation = encodeURIComponent(location);

	const google =
		`https://calendar.google.com/calendar/render?action=TEMPLATE` +
		`&text=${encodedTitle}` +
		`&details=${encodedDesc}` +
		`&location=${encodedLocation}` +
		`&dates=${dates}`;

	const outlook =
		`https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose` +
		`&rru=addevent` +
		`&subject=${encodedTitle}` +
		`&body=${encodedDesc}` +
		`&location=${encodedLocation}` +
		`&startdt=${encodeURIComponent(formattedStartDate)}` +
		`&enddt=${encodeURIComponent(formattedEndDate)}`;

	return { google, outlook };
};

export const buildICS = ({ title, description, location, start, end, timezone }) => {
	const uid = `${Date.now()}-${Math.random().toString(36).slice(2)}@add-to-calendar`;
	const dtstamp = formatDateICS(new Date());
	const dtstart = formatDateICS(start);
	const dtend = formatDateICS(end);
	const tzHint = timezone ? `\nX-WR-TIMEZONE:${escapeICS(timezone)}` : "";

	return (
		"BEGIN:VCALENDAR\n" +
		"VERSION:2.0\n" +
		"PRODID:-//AddToCalendar//EN\n" +
		`CALSCALE:GREGORIAN${tzHint}\n` +
		"METHOD:PUBLISH\n" +
		"BEGIN:VEVENT\n" +
		`UID:${uid}\n` +
		`DTSTAMP:${dtstamp}\n` +
		`DTSTART:${dtstart}\n` +
		`DTEND:${dtend}\n` +
		`SUMMARY:${escapeICS(title)}\n` +
		(description ? `DESCRIPTION:${escapeICS(description)}\n` : "") +
		(location ? `LOCATION:${escapeICS(location)}\n` : "") +
		"END:VEVENT\n" +
		"END:VCALENDAR\n"
	);
};